'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';
import callDealer from '../components/forsale/call-dealer';
import saveForLater from '../components/forsale/save-for-later';
import user from '../profile/user';
import clickableContainer from '../ui/clickable-container';
import layout from '../ui/layout';
import analytics from '../utils/analytics';
import history from '../utils/history';
import parkersCompareLink from '../utils/parkers-compare-links';

export function init() {
	baseInit();

	const locationPostcode = $.findByBem('cfs-search-results').attr('data-location-postcode');
	if (locationPostcode) {
		user.setLocation(null);
		user.setPostcode(locationPostcode);
	}

	import(/* webpackChunkName: "react-cfs-search" */ '../react/entry/cfs-search.js').then(function ({ renderSearch }) {
		renderSearch();
	});

	history.setState({ facetedSearch: true });

	// Force reload if back button used
	history.onStateChange((state) => {
		if (state && state.facetedSearch) {
			window.location.reload();
		}
	});

	callDealer.init();
	clickableContainer.init();
	parkersCompareLink.init();
	saveForLater.init('Click Search Results');

	$.findByBem('search-controls', 'filter-toggle').off('click.analytics').on('click.analytics', () => {
		analytics.trackEvent('Results filtering', 'Button Click', layout.getScreenSize());
	});
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}